import React, { ReactNode } from 'react';

import moment from 'moment/moment';
import { datetime } from '@bringg/types';

import styles from './tooltip.module.scss';

const renderValue = (key: string, value: string | number | ReactNode, identifier?: string) => (
	<div data-test-id={`${key}-${identifier || value}`} className={styles.valueContainer}>
		<span className={styles.key}>{key}:</span> <span className={styles.value}>{value}</span>
	</div>
);

const renderTime = (hourFormat: string, key: string, startTime: string | datetime, endTime?: string | datetime) => {
	if (!startTime) {
		return null;
	}
	const formatStartTime = moment(startTime).format(hourFormat);
	const value = endTime ? `${formatStartTime}  -  ${moment(endTime).format(hourFormat)}` : formatStartTime;
	return renderValue(key, value);
};

const renderText = (key: string, value: string) => {
	if (!value) {
		return null;
	}
	return renderValue(key, value);
};

export const tooltipProvider = {
	renderValue,
	renderText,
	renderTime
};
